import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';
import { usersRoutes } from '@feature/setting/users/users.routes';
import { contactsRoutes } from '@feature/setting/contacts/contacts.routes';
import { locationSetupRoutes } from '@feature/setting/location-setup/location-setup.routes';

export const settingRoutes: Routes = [
  {
    path: 'settings',
    loadComponent: () =>
      import('@feature/setting/setting.component').then(
        m => m.SettingComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'users',
      },
      {
        path: 'apps',
        canActivate: [permissionGuard('DispatcherToolsView')],
        loadComponent: () =>
          import('./apps/apps.component').then(m => m.AppsComponent),
      },
      {
        path: 'zone-categories',
        canActivate: [permissionGuard('DispatcherZoneCategoryView')],
        loadComponent: () =>
          import('./zone-categories/zone-categories.component').then(
            m => m.ZoneCategoriesComponent
          ),
      },
      {
        path: 'logs-reports',
        canActivate: [permissionGuard('DispatcherLoginAuditReportView')],
        loadComponent: () =>
          import('./logs-reports/logs-reports.component').then(
            m => m.LogsReportsComponent
          ),
      },
      {
        path: 'location-yards',
        canActivate: [permissionGuard('DispatcherLocationsYardsView')],
        loadComponent: () =>
          import('./location-yards/location-yards.component').then(
            m => m.LocationYardsComponent
          ),
      },
      {
        path: 'task-codes',
        canActivate: [permissionGuard('DispatcherTaskCodeView')],
        loadComponent: () =>
          import('./task-codes/task-code.component').then(
            m => m.TaskCodeComponent
          ),
      },
      {
        path: 'mapping-activity-log',
        canActivate: [permissionGuard('DispatcherMappingActivityLogView')],
        loadComponent: () =>
          import('./mapping-activity-log/mapping-activity-log.component').then(
            m => m.MappingActivityLogComponent
          ),
      },
      {
        path: 'mapping-activity-log/:id',
        canActivate: [permissionGuard('DispatcherMappingActivityLogView')],
        loadComponent: () =>
          import('./mapping-activity-log/components/mapping-activity-log-details/mapping-activity-log-details.component').then(
            c => c.MappingActivityLogDetailsComponent
          ),
      },
      ...usersRoutes,
      ...contactsRoutes,
      ...locationSetupRoutes,
    ],
  },
];
